'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * ObservationList — the thin standalone screen (#/PSRS/Observation/List) that hosts the Solr-backed, filterable
 * ObservationList provider. It owns only the page host div; the provider paints the whole list (filter bar + results)
 * into #ObservationList-Host and does the fetching. Full browser width via Dashboard Mode (the router drops the app
 * content gutters for a wide, dense list). Replaces the generic pict-section-recordset Observation list, which hangs
 * scanning the ~21k-row Observations table.
 */
class ObservationListView extends libPictView
{
	get provider() { return this.pict.providers['ObservationList']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			// Standalone screen is never project-locked — exit any embed carried over from a Project workspace tab.
			if (typeof tmpProvider.exitEmbed === 'function') { tmpProvider.exitEmbed(); }
			tmpProvider._mount = '#ObservationList-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ObservationListView;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationList',
	DefaultRenderable: 'ObservationListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reusable app-shell Dashboard Mode: render this dense filterable list full browser width.
	DashboardMode: true,

	CSS: /*css*/`
		.obl-page { padding: 1.25rem 0 2rem; }
	`,

	Templates:
	[
		{
			Hash: 'ObservationList-Template',
			Template: html`
				<section class="section obl-page">
					<div id="ObservationList-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'ObservationListWrap',
			TemplateHash: 'ObservationList-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
